import React, { useState,useEffect } from 'react'; 
import axios from 'axios'
import Header from './Header'
import { Link } from 'react-router-dom'
import copy from "copy-to-clipboard";
import QRCode from "react-qr-code";
import { AlignLeft } from 'react-feather';
var CryptoJS = require("crypto-js");

const Profile = () => { 
    const [ref_count, setref_count] = useState(0);
    const [email, setEmail] = useState('');
    const [msg, setMsg] = useState('');
    const [refid, setRefid] = useState('');
    const [newPassword, setnewPassword] = useState('');
    const [c_new_pass, setc_new_pass] = useState('');
    const [password, setpassword] = useState('');
    const [copiedrefid, setcopiedrefid] = useState(false);
    const [copiedLink, setCopiedLink] = useState(false);

    const copyRefId = (id) =>{
        setcopiedrefid(true)
        copy(id)
        setTimeout(()=>{
            setcopiedrefid(false)
        },2000)
    }
    const copyRefLink= (data) =>{
      setCopiedLink(true)
      copy(data)
      setTimeout(()=>{
        setCopiedLink(false)
      },2000)
  }

    const changeAccPass = () =>{
        setMsg(<i class="fa fa-circle-o-notch fa-spin mt-2" style={{fontSize:'30px',color:"#000"}}></i>)
        if(newPassword.length>0 && password.length>0 && c_new_pass.length>0){
            if(newPassword===c_new_pass){
          let newPass = newPassword
          let Email = email
          let Password = password
          let encrypted = CryptoJS.AES.encrypt(Email,"key")
          let encrypted1 = CryptoJS.AES.encrypt(Password,"key")
         
          axios.post("https://api.mahirefrigeration.com/api/AccChangePass",
          {
            encrypt1:encrypted.toString(),encrypt2:encrypted1.toString(),newPass:newPass
          })
          .then(res=>{
                  if(res.data){
                    setMsg("Successfully changed password , Kindly login again.")
                      setTimeout(()=>{
                          sessionStorage.clear();
                          window.location.reload();
                      },3000)
                  }
          })
          .catch(err=>{
            setMsg("Wrong old password")
          })
      }
      else{
        setMsg("Entered password doesn't match")
      }
        }
        else{
            setMsg("Kindly enter all details correctly")
        }
  }

    useEffect(() => {
        let token = sessionStorage.getItem("token")
        let email = sessionStorage.getItem("email")
              if(!token || !email){
                  window.location.href="/"
              }
              else{
                setEmail(email)
                const config = {
                  headers: { Authorization: `Bearer ${token}` }
              };
                axios.get("https://api.mahirefrigeration.com/api/validateToken",config)
                .then(async(res)=>{
                  if(res.data==='User validation failed'){
                    sessionStorage.clear();
                    window.location.href='/'
                  }
                  else{
                    setRefid(res.data.data._id)
                    const config = {
                      headers: { Authorization: `Bearer ${token}` }
                    };
                  
                  }
                })
              }
  },[]);
	return ( 
        <>
         <Header/>
         <div className="first_sec_ran">
          <div className='container mt-3'> 
            <div class="card" style={{width: "100%",backgroundColor:"#fff",border:"1px solid #252936",color:"#000"}}>
                  <div class="card-body">
                      <div className='mt-2' style={{textAlign:"center"}}>
                      <div className='row'>
                        <div className='col-md-12'>
                              <span style={{color:"#adadae"}}>Hello!</span><br/>
                            <i class="fa fa-user" style={{fontSize:"18px",cursor:"pointer",color:"#000",marginRight:"10px",color:"#62BD69"}} aria-hidden="true"></i>
                            <span  style={{fontSize:"19px"}}>{email}</span><br/>
                         
                        </div>
                      </div>
                      </div>
                     

                      <div className='mt-3' style={{textAlign:"left"}}>
                      <div class=" p-4" style={{width: "100%",height:"100%",borderRadius:"6px",backgroundColor:"#fff",color:"#000"}}>
                          <div className='row'>
                        <div className='col-md-6 col-sm-12 mt-3'>
                        <div className="form-group mb-6">
                        <label for="exampleInputPassword1" style={{fontWeight:'500'}}>Old Password</label>
                          <input type="password" class="form-control ProI" onChange={(e)=>setpassword(e.target.value)} name="password"  placeholder="Enter Old Password"/>
                      </div>
                        </div>
                        <div className='col-md-6 col-sm-12 mt-3'>
                        <div className="form-group">
                        <label for="exampleInputPassword1" style={{fontWeight:'500'}}>New Password</label>
                          <input type="password" class="form-control ProI" name="newPassword" onChange={(e)=>setnewPassword(e.target.value)}  placeholder="Enter New Password"/>
                      </div>
                        </div>
                        </div>  
                        <div className='row'>
                        <div className='col-md-6 col-sm-12 mt-3'>
                        <div className="form-group mb-6">
                        <label for="exampleInputPassword1" style={{fontWeight:'500'}}>Confirm New Password</label>
                          <input type="password" class="form-control ProI" onChange={(e)=>setc_new_pass(e.target.value)} name="password"  placeholder="Enter Old Password"/>
                      </div>
                        </div>
                        </div>  
                        <center>
                        <button type="button" onClick={changeAccPass} class="btn salon_user_button mt-3" style={{minWidth:"20%",border:"1px solid #62BD69"}} >Reset Password</button>  
                        <p className='mt-2'>{msg}</p>
                        </center>
                      </div>
                      </div>
                  </div>

                  </div>
          </div> 
          </div>
        </>
	); 
} 
export default Profile;